import { createI18n } from 'vue-i18n';
import fr from './locales/fr.json';
import en from './locales/en.json';

export type AppLocale = 'fr' | 'en';
export const SUPPORTED_LOCALES: AppLocale[] = ['fr', 'en'];
export const DEFAULT_LOCALE: AppLocale = 'fr';

const UI_LOCALE_KEY = 'osmos.uiLocale';

function readStoredLocale(): AppLocale {
  const raw = (typeof window !== 'undefined' && window.localStorage)
    ? window.localStorage.getItem(UI_LOCALE_KEY)
    : null;
  return raw === 'en' || raw === 'fr' ? raw : DEFAULT_LOCALE;
}

export const i18n = createI18n({
  legacy: false,
  locale: readStoredLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { fr, en },
});

export function setUiLocale(locale: AppLocale) {
  i18n.global.locale.value = locale;
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(UI_LOCALE_KEY, locale);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}
